<template>
  <div class="loading">
    <div class="modal" v-bind:class="{ 'is-active': isActive }">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="notification is-primary has-text-centered">
          <span>
            <font-awesome-icon :icon="spinner" size="3x" pulse fixed-width />
          </span>
          <h1>{{message}}</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';

export default {
  name: 'loading',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: 'Loading...',
    },
  },
  components: {
    'font-awesome-icon': FontAwesomeIcon,
  },
};
</script>

<style lang="sass" scoped>
.modal
  .notification
    h1 
      margin: 1rem 0 0 0
      font-size: 1.25rem
    
    i
      margin: 1rem 0 0 0

</style>

    


// WEBPACK FOOTER //
// src/components/Loading.vue